import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Chat, Home } from "@mui/icons-material";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import * as PracticeActions from "../../state/redux/practiceSession";
import * as TrialActions from "../../state/redux/trialSession";
import OmniToolbar from "./omniToolbar";
import PortalAvatar from "./portalAvatar";

const PortalAppBar = props => {
  const {
    title = "Welcome",
    belowTitle = "Welcome",
    hideMenu = true,
    botpressStyle = false,
    awsGroup,
    hideAvatar = false,
  } = props;

  const theme = useTheme();

  const currentDepth = window.location.pathname.split("/").length;

  const currentRoute = window.location.pathname;

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));

  if (botpressStyle) {
    return (
      <AppBar
        sx={{
          boxShadow: "none",
          borderBottom: `1px solid ${theme.palette.primary.light}`,
          paddingLeft: theme.spacing(1),
          zIndex: "998",
        }}
      >
        <OmniToolbar disableGutters={true}>
          <Box
            sx={[
              {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
              },
              currentDepth > 2 && {
                marginLeft: `-${theme.spacing(1)}`,
              },
            ]}
          >
            <Typography
              variant="overline"
              noWrap
              component="div"
              sx={[
                { marginLeft: theme.spacing(1), marginBottom: 0 },
                { flexGrow: 1 },
                smallScreen && { maringTop: `-${theme.spacing(2)}` },
              ]}
            >
              Organization:{" "}
              {props.organizationODM ? props.organizationODM.omniData.name : "Quick Navigation"}
            </Typography>
            <Box
              sx={{
                flexGrow: 1,
                // display: { xs: "none", md: "flex" },
                marginTop: `-${theme.spacing(2)}`,
              }}
            >
              <Button
                key={"AI Overview"}
                sx={[
                  {
                    color: theme.palette.primary.contrastText,
                    fontSize: "18px",
                    marginBottom: `-${theme.spacing(1)}`,
                  },
                  currentRoute === constants.appPaths.appPathPartner && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                  currentRoute === constants.appPaths.appPathProvider && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                  currentRoute === constants.appPaths.appPathAdmin && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                ]}
                onClick={() => {
                  props.history.push("/");
                }}
              >
                {!smallScreen && (
                  <Home
                    fontSize="medium"
                    sx={{ marginRight: theme.spacing(0.5), marginTop: "-2px" }}
                  />
                )}
                {!smallScreen && "Dashboard"}
                {smallScreen && (
                  <Home
                    fontSize="small"
                    sx={{ marginRight: theme.spacing(0.5), marginTop: "-2px" }}
                  />
                )}
                {smallScreen && "Home"}
              </Button>
              <Button
                key={"ConversationsStuff"}
                sx={[
                  {
                    color: theme.palette.primary.contrastText,
                    fontSize: "18px",
                    marginBottom: `-${theme.spacing(1)}`,
                  },
                  currentRoute === constants.appPaths.appPathAdminBotpressConversations && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                  currentRoute === constants.appPaths.appPathProviderBotpressConversations && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                  currentRoute === constants.appPaths.appPathPartnerBotpressConversations && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                ]}
                onClick={() => {
                  if (awsGroup === constants.userGroups.Administrator) {
                    props.history.push(constants.appPaths.appPathAdminBotpressConversations);
                  } else if (awsGroup === constants.userGroups.Provider) {
                    props.history.push(constants.appPaths.appPathProviderBotpressConversations);
                  } else if (awsGroup === constants.userGroups.Partner) {
                    props.history.push(constants.appPaths.appPathPartnerBotpressConversations);
                  }
                }}
              >
                {!smallScreen && (
                  <Chat
                    fontSize="medium"
                    sx={{ marginRight: theme.spacing(0.5), marginTop: theme.spacing(0.25) }}
                  />
                )}
                {!smallScreen && "Conversations"}
                {smallScreen && (
                  <Chat
                    fontSize="small"
                    sx={{ marginRight: theme.spacing(0.5), marginTop: theme.spacing(0.25) }}
                  />
                )}
                {smallScreen && "HIST"}
              </Button>
              <Button
                key={"Test Harness"}
                sx={[
                  {
                    color: theme.palette.primary.contrastText,
                    fontSize: "18px",
                    marginBottom: `-${theme.spacing(1)}`,
                  },
                  currentRoute === constants.appPaths.appPathPartnerBotpressTestHarness && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                  currentRoute === constants.appPaths.appPathProviderBotpressTestHarness && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                  currentRoute === constants.appPaths.appPathAdminBotpressTestHarness && {
                    textDecoration: "underline",
                    fontWeight: "bold",
                  },
                ]}
                onClick={() => {
                  if (awsGroup === constants.userGroups.Administrator) {
                    props.history.push(constants.appPaths.appPathAdminBotpressTestHarness);
                  } else if (awsGroup === constants.userGroups.Provider) {
                    props.history.push(constants.appPaths.appPathProviderBotpressTestHarness);
                  } else if (awsGroup === constants.userGroups.Partner) {
                    props.history.push(constants.appPaths.appPathPartnerBotpressTestHarness);
                  }
                }}
              >
                {!smallScreen && (
                  <AssignmentRoundedIcon
                    fontSize="medium"
                    sx={{ marginRight: theme.spacing(0.5), marginTop: "-2px" }}
                  />
                )}
                {!smallScreen && "Test Harness"}
                {smallScreen && (
                  <AssignmentRoundedIcon
                    fontSize="small"
                    sx={{ marginRight: theme.spacing(0.5), marginTop: theme.spacing(0.25) }}
                  />
                )}
                {smallScreen && "Test"}
              </Button>
            </Box>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <PortalAvatar />
          </Box>
        </OmniToolbar>
      </AppBar>
    );
  } else {
    return (
      <AppBar
        sx={{
          boxShadow: "none",
          borderBottom: `1px solid ${theme.palette.primary.light}`,
          paddingLeft: theme.spacing(1),
          zIndex: "998",
        }}
      >
        <OmniToolbar disableGutters={true}>
          <Box
            sx={[
              {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
              },
              currentDepth > 2 && {
                marginLeft: `-${theme.spacing(1)}`,
              },
            ]}
          >
            <Typography
              variant="overline"
              noWrap
              component="div"
              sx={[hideMenu && { marginLeft: theme.spacing(1), marginBottom: 0 }, { flexGrow: 1 }]}
            >
              {title}
            </Typography>
            <Typography
              variant="h5"
              noWrap
              component="div"
              sx={[
                hideMenu && { marginLeft: theme.spacing(1), marginTop: `-${theme.spacing(1)}` },
                { flexGrow: 1 },
              ]}
            >
              {props.organizationODM ? props.organizationODM.omniData.name : belowTitle}
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 0 }}>{!hideAvatar && <PortalAvatar />}</Box>
        </OmniToolbar>
      </AppBar>
    );
  }
};

const mapStateToProps = state => ({
  bpShowChat: state.userSession.bpShowChat,
  organizationODM: state.userSession.organizationODM,

  awsGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {
  setCurrentTrialRequest: TrialActions.setCurrentTrialRequest,
  setPracticeODMRequest: PracticeActions.setPracticeODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PortalAppBar));
